import { DIRECT_CONVERSION_OFFER_ENDS_AT_STORAGE_KEY, ENTRY_INTRO_OFFER_WINDOW_MS } from './entryIntroOffer';
const offerStorage = () => {
    if (typeof globalThis.localStorage === 'undefined')
        return null;
    return globalThis.localStorage;
};
export const getOrCreateDirectConversionOfferEndsAt = () => {
    const storage = offerStorage();
    const existing = storage?.getItem(DIRECT_CONVERSION_OFFER_ENDS_AT_STORAGE_KEY)?.trim();
    if (existing) {
        const parsed = Date.parse(existing);
        if (Number.isFinite(parsed)) {
            return new Date(parsed);
        }
    }
    const endsAt = new Date(Date.now() + ENTRY_INTRO_OFFER_WINDOW_MS);
    storage?.setItem(DIRECT_CONVERSION_OFFER_ENDS_AT_STORAGE_KEY, endsAt.toISOString());
    return endsAt;
};
export const clearDirectConversionOfferEndsAt = () => {
    offerStorage()?.removeItem(DIRECT_CONVERSION_OFFER_ENDS_AT_STORAGE_KEY);
};
//# sourceMappingURL=directConversionOfferWindow.js.map